import { StyleSheet } from 'react-native';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { brand, neutrals, stroke, text } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderRadius: 12,
    padding: 2,
    backgroundColor: neutrals.neutralGrays.crystal,
    alignSelf: 'flex-start',
    gap: 4,
  },
  option: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: 'transparent',
  },
  activeOption: {
    backgroundColor: brand.main.variations['lighterWater-3'],
    borderColor: stroke.strokeColorActive,
  },
  text: {
    color: text.color.textPrimary,
    ...textLatoStyleDS.BodyRegularSm,
  },
  activeText: {
    ...textLatoStyleDS.BodyBoldSm,
  },
});
